// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MedicalUnitDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class MedicalUnitApiClient extends BaseCRUDApiClient<MedicalUnitDto> {
  baseUrl = this.config.apiEndpoint + '/medical-unit';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
